import get from 'lodash/get';
import has from 'lodash/has';
import { QUICK_LINKS_PAGE_URL } from 'src/constants/urlConstants';
import { isAgencyApproved } from 'src/utils/agencyStatusHelper';

export const isLimitedAccess = (agencyName, agencyStatus) =>
  !(!!agencyName && isAgencyApproved(agencyStatus));

export const getActionsList = (adviceUrl, guideUrl, userRoles = []) => ({
  dashboard: {
    url: QUICK_LINKS_PAGE_URL,
  },
  accounts: {
    url: `/recent-submissions`,
  },
  advice: {
    url: adviceUrl,
  },
  appetite_guide: {
    url: guideUrl,
  },
  my_agency: {
    isShown: userRoles.includes('principal_agent'),
    url: `/my-agency`,
  },
});

export const getHeaderActionsFromMode = (applicationMode, actionsName) =>
  get(applicationMode, `subagent_header.${actionsName}`, []);

export const configureActionsArray = (actions, headerActions) =>
  headerActions.reduce((validActionsArr, action) => {
    const containedIsShown = has(actions, `${action}.isShown`);
    const isShown = get(actions, `${action}.isShown`, false);
    const isPushValidAction =
      !containedIsShown || (isShown && actions[action].isShown);

    if (isPushValidAction) {
      validActionsArr.push({
        name: action,
        url: actions[action].url,
      });
    }

    return validActionsArr;
  }, []);

export const getHeaderActions = (
  config,
  userRoles,
  agencyName,
  agencyStatus,
) => {
  if (isLimitedAccess(agencyName, agencyStatus)) return {};
  const { adviceUrl, guideUrl, applicationMode } = config;
  const actions = getActionsList(adviceUrl, guideUrl, userRoles, agencyStatus);

  const mainHeaderActions = getHeaderActionsFromMode(
    applicationMode,
    'main_actions',
  );
  const secondaryHeaderActions = getHeaderActionsFromMode(
    applicationMode,
    'secondary_actions',
  );

  const mainActions = configureActionsArray(actions, mainHeaderActions);
  const secondaryActions = configureActionsArray(
    actions,
    secondaryHeaderActions,
  );

  return { mainActions, secondaryActions };
};
